// api/classrooms : 教室の情報の操作をするAPI

import Api from './api_base'

export default {
  // GET /classrooms 全教室情報を取得する
  get: (id) => {
    return Api.get('/classrooms?id=' + id)
  },
  // POST /classrooms 教室情報を登録する param{ name: 'classroom_name'}
  post: (classroom) => {
    return Api.post('/classrooms', classroom)
  },
  // DELETE /classrooms/{id} 指定したidの教室情報を削除する
  delete: (id) => {
    return Api.delete('/classrooms/' + id)
  },
  // PUT /classrooms 教室情報を変更する param{ name: 'classroom_name', classroom_id: 'classroom_id}
  put: (classroom) => {
    return Api.put('/classrooms', classroom)
  }
}



// WEBPACK FOOTER //
// ./src/api/classrooms.js